import anime from 'animejs';

const dropdownLink = document.querySelector('.main-nav__container .menu-item.dropdown a');
const subMenu = document.querySelector('.main-nav__sub-menu');
const header = document.querySelector('header');
let headerHeight = header.offsetHeight;
let subMenuHeight = subMenu.offsetHeight;

// Featured Products submenu toggle
const submenuToggle = (e, instant = false) => {
    // prevent behavior from being inherited by children
    if (e !== null) {
        if (e.target !== e.currentTarget) {
            return;
        }
        e.preventDefault();
    }

    const expanded = dropdownLink.getAttribute('aria-expanded');
    const duration = instant ? 0 : 300;

    if (expanded === 'false') {
        dropdownLink.classList.add('expanded');
        subMenu.classList.add('main-nav__sub-menu--visible');
        anime({
            targets: subMenu,
            //top: subMenuHeight + headerHeight,
            top: header.offsetHeight,
            easing: 'linear',
            duration
        });
        dropdownLink.setAttribute('aria-expanded', 'true');
    } else {
        anime({
            targets: subMenu,
            //translateY: 0,
            top: -subMenu.offsetHeight,
            easing: 'linear',
            duration,
            complete: () => {
                subMenu.classList.remove('main-nav__sub-menu--visible');
            }
        });
        dropdownLink.setAttribute('aria-expanded', 'false');
        dropdownLink.classList.remove('expanded');
    }
};

dropdownLink.addEventListener('click', submenuToggle);

// menu sliding up/sliding down as user scrolls
let currentUserYPos = window.scrollY;

const showOrHideHeader = () => {
    const newUserYPos = window.scrollY;
    const scrollingDown = currentUserYPos < newUserYPos;
    const headerVisible = header.getAttribute('data-visible') !== 'false';

    if (scrollingDown && headerVisible && newUserYPos > headerHeight) {
        //===========
        // testing
        // disabled sub menu collapse on scroll
        //===========
        // headerSlideUp();
    } else if (!scrollingDown && !headerVisible) {
        headerSlideDown();
    }

    // Record the user's new scroll position no matter what.
    currentUserYPos = window.scrollY;
};

const headerSlideUp = () => {
    if (dropdownLink.getAttribute('aria-expanded') === 'true') {
        anime({
            targets: header,
            translateY: -headerHeight - subMenuHeight,
            easing: 'linear',
            duration: 250,
            complete: () => {
                /*header.setAttribute(
                    'style',
                    `position: absolute; transform: translateY(-${headerHeight}px)`
                );*/
                header.setAttribute(
                    'style',
                    `position: absolute; top: -${subMenu.offsetHeight}px`
                );
                header.setAttribute('data-visible', 'false');
                submenuToggle(null, true);
            }
        });
    } else {
        anime({
            targets: header,
            translateY: -headerHeight,
            easing: 'linear',
            duration: 200,
            complete: () => {
                /*header.setAttribute(
                    'style',
                    `position: absolute; transform: translateY(-${headerHeight}px)`
                );*/
                header.setAttribute(
                    'style',
                    `position: absolute; top: -${subMenu.offsetHeight}px`
                );
                header.setAttribute('data-visible', 'false');
            }
        });
    }
};

const headerSlideDown = () => {
    anime({
        targets: header,
        translateY: 0,
        easing: 'linear',
        duration: 200,
        begin: () => {
            //header.setAttribute('style', `position: fixed; transform: translateY(0px)`);
            header.setAttribute('style', `position: fixed; top: 0px`);
        },
        complete: () => {
            header.setAttribute('data-visible', 'true');
        }
    });
};

addEventListener('scroll', showOrHideHeader);
